import {StoppageInfo} from '@domain/stoppages'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {useUpmPlantsContext} from '@hconnect/upm'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Suspense, useCallback} from 'react'
import {RouteObject, useLocation, useNavigate} from 'react-router'

import {StoppageList} from '../components'
import {stoppageListFeatureTranslations} from '../localization'
import {StoppageNavigationProvider} from '../providers'

const rcfaFeatureName = 'RcfaList'

const SuiteStoppageNavigationProvider = ({children}: {children: React.ReactNode}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const upmPlants = useUpmPlantsContext()

  const navigateToAnalysis = useCallback(
    async (stoppage: StoppageInfo) => {
      const upmId = upmPlants?.[stoppage.plantId!]?.upmId
      await navigate(
        `/${rcfaFeatureName}/hierarchyId/${upmId}/graphDetail/${stoppage.analysisId}/graph`,
        {
          state: location
        }
      )
    },
    [navigate, location, upmPlants]
  )

  const navigateToCreateAnalysis = useCallback(
    async (stoppage: StoppageInfo) => {
      const upmId = upmPlants?.[stoppage.plantId!]?.upmId
      await navigate(`/${rcfaFeatureName}/hierarchyId/${upmId}/new?type=stoppage`, {
        state: {selectedStoppage: stoppage}
      })
    },
    [navigate, upmPlants]
  )

  return (
    <StoppageNavigationProvider
      navigateToAnalysis={navigateToAnalysis}
      navigateToCreateAnalysis={navigateToCreateAnalysis}
    >
      {children}
    </StoppageNavigationProvider>
  )
}

const RoutesWrapper = ({children}: {children: React.ReactNode}) => {
  return (
    <ThemeProvider theme={useFundamentalMuiTheme()}>
      <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SuiteStoppageNavigationProvider>{children}</SuiteStoppageNavigationProvider>
        </LocalizationProvider>
      </Suspense>
    </ThemeProvider>
  )
}

export const stoppageListRoutes: RouteObject = {
  path: '',
  element: (
    <FeatureTranslationsLoader translations={stoppageListFeatureTranslations}>
      <RoutesWrapper>
        <StoppageList />
      </RoutesWrapper>
    </FeatureTranslationsLoader>
  )
}
